import React, { useState, useEffect, useMemo } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { inspectionTimeUpdate, getStationSummary } from '../../modules/analytics';
import './dashboard.css';

const StationSelector = ({ pageTitle }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const { userStationList: stations = [], inspectionTime } = useSelector(
    state => state.analytics || {}
  );
  const selectedStationId = inspectionTime?.stationId;
  const selected =
    stations.find(s => s.stationId === selectedStationId) || {};

  useEffect(() => {
    if (selectedStationId) {
      dispatch(getStationSummary(selectedStationId));
    }
  }, [dispatch, selectedStationId]);

  const sortedStations = useMemo(
    () => [...stations].sort((a, b) => {
      const nameA = a.stationName || '';
      const nameB = b.stationName || '';
      return nameA.localeCompare(nameB, undefined, { sensitivity: 'base', numeric: true });
    }),
    [stations]
  );

  const toggle = () => setOpen(prev => !prev);

  const selectStation = id => {
    const payload = {
      ...inspectionTime,
      stationId: id,
      stationInfo: stations.find(s => s.stationId === id) || {},
    };
    dispatch(inspectionTimeUpdate(payload));
    setOpen(false);
  };

  return (
    <div className="topSelector">
      <div className="topSelectorContent">
        <div className="pageTitle">{pageTitle}</div>
        <div className="pageSubtitle" onClick={toggle}>
          <div className="siteTitle">
            {selected.stationName || 'Select Station'}
          </div>
          <div className="dropdownToggle">
            <DownOutlined />
          </div>
          {open && (
            <ul className="stationOptions" onClick={(e) => e.stopPropagation()}>
              {sortedStations.map(s => (
                <li
                  key={s.stationId}
                  onClick={(e) => {
                    e.stopPropagation();
                    selectStation(s.stationId);
                  }}
                >
                  {s.stationName}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default StationSelector;
